import styled, { css } from 'styled-components';
var Item = styled.div.withConfig({
  displayName: "TrolleyItemstyles__Item",
  componentId: "b57xp0-0"
})(["position:relative;display:flex;flex-direction:column;margin:0;", ""], function (props) {
  return props.itemType === 'primary' && css(["padding:0;& + &{margin-top:10px;}img{padding:5px;margin:0;border:1px solid ", ";background:", ";}"], props.theme.color.monochrome.light, props.theme.color.monochrome.white);
});
var ItemRow = styled.div.withConfig({
  displayName: "TrolleyItemstyles__ItemRow",
  componentId: "b57xp0-1"
})(["padding-top:5px;justify-content:space-between;align-items:center;flex-wrap:nowrap;"]);
var PriceRow = styled.div.withConfig({
  displayName: "TrolleyItemstyles__PriceRow",
  componentId: "b57xp0-2"
})(["margin-top:8px;"]);
var Detail = styled.div.withConfig({
  displayName: "TrolleyItemstyles__Detail",
  componentId: "b57xp0-3"
})(["margin-right:0;max-width:inherit;flex:1 1 auto;font-size:", ";"], function (props) {
  return props.theme.font.size.base;
});
var Quantity = styled.div.withConfig({
  displayName: "TrolleyItemstyles__Quantity",
  componentId: "b57xp0-4"
})(["margin:3px 0 10px;color:", ";font-weight:", ";svg{margin-right:5px;position:relative;top:2px;fill:", ";}"], function (props) {
  return props.theme.color.palette['brand-1'];
}, function (props) {
  return props.theme.font.weight.bold;
}, function (props) {
  return props.theme.color.palette['brand-1'];
});
var Thumbnail = styled.div.withConfig({
  displayName: "TrolleyItemstyles__Thumbnail",
  componentId: "b57xp0-5"
})(["max-width:65px;height:auto;margin-right:20px;vertical-align:bottom;text-align:left;svg{display:inline-block;font-size:48px;text-align:center;min-width:65px;}", ""], function (props) {
  return props.isMonthlyCare && css(["a{pointer-events:none;}"]);
});
var ItemName = styled.a.withConfig({
  displayName: "TrolleyItemstyles__ItemName",
  componentId: "b57xp0-6"
})(["text-decoration:none;:hover{text-decoration:underline;}", ""], function (props) {
  return props.isMonthlyCare && css(["pointer-events:none;"]);
});
var ItemPrice = styled.div.withConfig({
  displayName: "TrolleyItemstyles__ItemPrice",
  componentId: "b57xp0-7"
})(["display:flex;flex-direction:column;align-items:center;span{font-size:", ";font-weight:", ";}", ""], function (props) {
  return props.theme.font.size['display-1'];
}, function (props) {
  return props.theme.font.weight.bold;
}, function (props) {
  return props.direction === 'row' && css(["flex-direction:row;justify-content:center;small{font-weight:", ";}"], props.theme.font.weight.bold);
});
var CheckboxWrapper = styled.div.withConfig({
  displayName: "TrolleyItemstyles__CheckboxWrapper",
  componentId: "b57xp0-8"
})(["margin:15px 0;background:", ";"], function (props) {
  return props.theme.color.palette['brand-1-light'];
});
var Label = styled.label.withConfig({
  displayName: "TrolleyItemstyles__Label",
  componentId: "b57xp0-9"
})(["line-height:1.5rem;font-size:15px;&& a{text-decoration:none;color:", ";&:hover{text-decoration:underline;}}"], function (props) {
  return props.theme.color.palette['brand-1'];
});
var CareBox = styled.div.withConfig({
  displayName: "TrolleyItemstyles__CareBox",
  componentId: "b57xp0-10"
})(["border:1px solid ", ";justify-content:center;max-width:49%;text-align:center;padding:16px;", " &&{> button{margin-bottom:0.625rem;}}.monthlyAlert{text-align:left;background:", ";}"], function (props) {
  return props.theme.color.monochrome.light;
}, function (props) {
  return css(["@media only screen and (max-width:", "){max-width:none;margin-bottom:15px;}"], props.theme.size.breakpoint['max-width'].sm);
}, function (props) {
  return props.theme.color.semantic.info.lighter;
});
var CareProductWrapper = styled.div.withConfig({
  displayName: "TrolleyItemstyles__CareProductWrapper",
  componentId: "b57xp0-11"
})(["display:flex;flex-direction:row;justify-content:space-between;"]);
var CareNameWrapper = styled.div.withConfig({
  displayName: "TrolleyItemstyles__CareNameWrapper",
  componentId: "b57xp0-12"
})(["display:flex;flex-direction:column;align-items:flex-start;justify-content:flex-start;text-align:left;padding-right:16px;h4{margin-bottom:0;}"]);
var CarePriceWrapper = styled.div.withConfig({
  displayName: "TrolleyItemstyles__CarePriceWrapper",
  componentId: "b57xp0-13"
})(["display:flex;flex-direction:column;align-items:flex-end;flex:0 0 auto;margin-top:2px;"]);
export { Item, ItemRow, PriceRow, Detail, Quantity, Thumbnail, ItemName, ItemPrice, CheckboxWrapper, Label, CareBox, CarePriceWrapper, CareProductWrapper, CareNameWrapper };